<template>
    <div>
        <Dropdown v-if="isDoctors"
                  class="w100"
                  v-model="$store.state.selectedEquipmentId"
                  :options="vuexGetters_Equipments"
                  optionLabel="EquipmentName"
                  :filter="true"
                  placeholder="Doktor seçimi yapınız."
                  :showClear="true"
                  @change="setSelectedEquipment()">
        </Dropdown>
        <div class="row"
             v-if="!isDoctors &&( vuexGetters_calendarOfEquipments==null || vuexGetters_calendarOfEquipments.length==0)">
            <label style="text-align:center;width:100%;">Herhangi bir çalışma saati bulunamamıştır.</label>
        </div>
        <div v-else>
            <Carousel v-model="$store.state.RequestDate"
                      :value="vuexGetters_calendarOfEquipments"
                      :numVisible="7" :numScroll="3"
                      :responsiveOptions="responsiveOptions"
                      v-if="vuexGetters_SelectedEquipmentId!=null && !isDoctors">
                <!--<template #header>
                    <h5>Basic</h5>
                </template>-->
                <template #item="slotProps">
                    <div class="product-item">
                        <div class="product-item-content">
                            <div class="p-mb-3">
                            </div>
                            <div>
                                <h4 style="text-align:center" class="p-mb-1">{{slotProps.data.day}}</h4>
                                <Button v-for="time in slotProps.data.times" :key="time"
                                        :class="{
                                        active:(time.RequestDetails.RequestStartDate == $store.state.RequestStartDate && time.RequestDetails.RequestEndDate == $store.state.RequestEndDate),
                                        'button-green': time.RequestDetails.IsEmpty==true,
                                        'button-red': time.RequestDetails.IsEmpty==false}"
                                        @click="selectDate(time.RequestDetails);"
                                        :disabled="!time.RequestDetails.IsEmpty"
                                        :label="time.RequestDetails.RequestStartDate.split('T')[1].substring(0,5)"
                                        class="p-button-sm w100" />
                            </div>
                        </div>
                    </div>
                </template>
            </Carousel>
        </div>
    </div>
</template>


<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { common } from "../../javascripts/customMethods";

    export default {
        props: ["isDoctors"],
        data() {
            return {
                responsiveOptions: [
                    {
                        breakpoint: '1024px',
                        numVisible: 7,
                        numScroll: 7
                    },
                    {
                        breakpoint: '850px',
                        numVisible: 5,
                        numScroll: 5
                    },
                    {
                        breakpoint: '600px',
                        numVisible: 4,
                        numScroll: 4
                    },
                    {
                        breakpoint: '480px',
                        numVisible: 3,
                        numScroll: 3
                    },
                    {
                        breakpoint: '350px',
                        numVisible: 2,
                        numScroll: 2
                    },
                    {
                        breakpoint: '250px',
                        numVisible: 1,
                        numScroll: 1
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(["vuexGetters_Equipments", "vuexGetters_SelectedEquipmentId", "vuexGetters_calendarOfEquipments"])
        },
        methods: {
            ...mapActions(["vuexAction_GetEquipments", "vuexAction_GetCalendarOfEquipments"]),
            ...mapMutations(["vuexMutation_UpdateStepLevel", "vuexMutation_setRequestDate"]),
            getDateTime(date) {
                return common.FormatDateTime2(date, true);
            },
            setSelectedEquipment() {
                this.vuexAction_GetCalendarOfEquipments().then(res => {
                    this.vuexMutation_UpdateStepLevel(1);
                });
            },
            selectDate(RequestDetails) {
                //kişisel bilgiler sekmesini aktif et ve aç.
                this.vuexMutation_UpdateStepLevel(0);
                setTimeout(() => {
                    this.vuexMutation_UpdateStepLevel(2);
                }, 1)
                this.vuexMutation_setRequestDate(RequestDetails);
            }
        },
        created() {
            this.vuexAction_GetEquipments();
        }
    }
</script>
<style scoped>

    .button-red {
        background-color: #808080;
        border-color: #686767;
    }

        .button-red:enabled:hover {
            background: #808080;
            color: #ffffff;
            border-color: unset !important;
        }

    .button-redd {
        background-color: #c71a1a;
        border-color: #c71a1a;
    }

        .button-redd:enabled:hover {
            background: #c71a1a;
            color: #ffffff;
            border-color: unset !important;
        }

    .button-green {
        background-color: #28a745;
        border-color: #28a745;
    }

        .button-green:enabled:hover {
            background: #208638;
            color: #ffffff;
            border-color: unset !important;
        }

    button.active {
        background-color: #055f1a !important;
    }
</style>